import ElavonForm from "components/Companies/Webflow/ElavonForm";
import PaymentDisclaimer from "./PaymentDisclaimer";
import { Button } from "@mui/material";
import { useState } from "react";
import LoadingButton from "@mui/lab/LoadingButton";

export default function PaymentForm(props: any) {

    const { 
        planInfo, 
        updatePlan,
        style = 'default',
        setOpenDialog
    } = props;
    
    const [isLoading, setIsLoading] = useState(false);
    
    const handleUpdatePlan = async () => {
        setIsLoading(true);
        try {
            await updatePlan();
        } finally {
            setIsLoading(false);
        }
    };
    
    return (
        <div>
            
            {style === 'custom' && (
            <h2 className="payment_form_title">Change Plan</h2>
            )}

            <PaymentDisclaimer planInfo={planInfo} />
            {(planInfo && planInfo.data && planInfo.data.calculated_price.price > 0) ? (
                <ElavonForm 
                    updatePlan={updatePlan}
                    amount={planInfo.data.calculated_price.price}
                    style={style}
                    setOpenDialog={setOpenDialog}
                />
            ) : (
                <>
                    {style === 'custom' && (
                        <div id='DialogPaymentInfo'>
                            
                        </div>
                    )}


                    
                    <div className="plan_buttons">
                        {style === 'custom' && (
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={() => setOpenDialog(false)}
                            fullWidth
                        >
                            Cancel
                        </Button>
                        )}
                        <LoadingButton
                            variant="contained"
                            color="primary"
                            onClick={handleUpdatePlan}
                            loading={isLoading}
                            fullWidth
                        >
                            Continue
                        </LoadingButton>

                    </div>
                    



                </>
            )}
        </div>
    )
}


// Change Plan
// Current Plan:
// Essentials + - Yearly
// $ 456 / Year
// Plan Selected:
// Starter Plan - Yearly
// $ 0 / Year
// You Will Be Charged $0 Today. Your Next Billing Cycle Will Continue With Your New Plan Rate.